<template>
  <div class="indexcontiner">
    
    <div  class="car_continer">
      <el-carousel  >
        <el-carousel-item v-for="item in texts"  :key="item">
          <div style="flex-direction:  column;width:100%;height:100%;display:flex;justify-content: center;align-items: center;position: relative;">
            <div style="height:100%;width:100%;position: absolute;">
              <img style="object-fit: cover;height:65vh;width:100%" :src="item.src" alt="">
            </div>
            <div class="carousel_text" >
              <div class="car_title">{{ item.title }}</div>
              <div class="car_data">{{item.data}}</div>
            </div>
            
          </div>
        </el-carousel-item>
    </el-carousel>
    </div>
    <div class="dbchar">
      <span style="font-size:4vh;font-weight:600;">数据库亮点</span>
      <div class="dbcontiner">
        <div class="dbitem">
          <div class="dbitems items_active">
            
              <div class="itemcont_top">
                <img style="height:3vh;width:3vh"src="../assets/duoweidu.svg" alt="SVG图形">
                <span>多维度分析</span>
              </div>
              <div class="itemcont_bottom">
                <el-popover placement="right" title="排放基线 提供了各品类作物全国平均排放基线" width="350" trigger="hover">
                  <div class="popver_continer">
                    <img src="../assets/index/main4.gif" alt="">
                  </div>
                  <div slot="reference">
                    <span class="spanitem">排放基线</span><br>
                  </div>
                </el-popover>

                <el-popover placement="right" title="时间规律 查询各作物的碳足迹时间变化趋势" width="350" trigger="hover">
                  <div class="popver_continer">
                    <img src="../assets/index/main2.gif" alt="">
                  </div>
                  <div slot="reference">
                    <span class="spanitem">时间规律</span><br>
                  </div>
                </el-popover>

                <el-popover placement="right" title="区域特征 提供省级层面的碳足迹数据" width="350" trigger="hover">
                  <div class="popver_continer">
                    <img src="../assets/index/main3.gif" alt="">
                  </div>
                  <div slot="reference">
                    <span class="spanitem">区域特征</span><br>
                  </div>
                </el-popover>
                
              </div>
            
          </div>
          <div class="dbitems items_active">
            <div class="itemcont_top">
                <img style="height:3vh;width:3vh"src="../assets/jingzhun.svg" alt="SVG图形">
                <span >精准核算</span>
              </div>
              <div class="itemcont_bottom">

                <el-popover placement="right" title="生命周期评价法 确保碳足迹核算的科学性和准确性" width="350" trigger="hover">
                  <div class="popver_continer">
                    <span>生命周期评价法（LCA）是一种定量价整个供应链环境影响的方法，它能够在能源使用效率、环境影响和可持续 性方面比较不同的生产系统。</span>
                  </div>
                  <div slot="reference">
                    <span class="spanitem">生命周期评价法</span><br>
                  </div>
                </el-popover>

                <el-popover placement="right" title="清晰核算边界 确保数据的全面性" width="350" trigger="hover">
                  <div class="popver_continer">
                    <img src="../assets/index/item2_2.png" alt="">
                  </div>
                  <div slot="reference">
                    <span class="spanitem">清晰核算边界</span><br>
                  </div>
                </el-popover>

                <el-popover placement="right" title="动态更新 保持数据的时效性和准确性" width="350" trigger="hover">
                  <div class="popver_continer">
                    <img src="../assets/index/main3.gif" alt="">
                  </div>
                  <div slot="reference">
                    <span class="spanitem">动态更新</span><br>
                  </div>
                </el-popover>

                
                
              </div>
          </div>
        </div>
        <div class="dbmain items_active">
          
          <div class="itemcont_top ">
                <img style="height:3vh;width:3vh"src="../assets/duopinlei.svg" alt="SVG图形">
                <span >多品类多时空尺度数据集</span>
          </div>
          <div class="itemcont_main_bottom" style="">

                <el-popover  placement="right" title="25种农产品 确保碳足迹核算的科学性和准确性" trigger="hover">
                  <div class="popver_continer">
                    <img src="../assets/index/main1.gif" alt="">
                  </div>
                  <div slot="reference">
                    <span class="spanitem">27种农产品</span><br>
                    
                  </div>
                  
                </el-popover>
                <el-popover placement="right" title="近20年时间跨度 确保数据的全面性" trigger="hover">
                  <div class="popver_continer">
                    <img src="../assets/index/main2.gif" alt="">
                  </div>
                  <div slot="reference">
                    <span class="spanitem">近20年时间跨度</span><br>
                    
                  </div>
                  
                </el-popover>
                <el-popover placement="right" title="省级空间尺度 保持数据的时效性和准确性"  trigger="hover">
                  <div class="popver_continer">
                    <img src="../assets/index/main3.gif" alt="">
                  </div>
                  <div slot="reference">
                    <span class="spanitem">省级空间尺度 </span><br>
                    
                  </div>
                  
                </el-popover>  
                   
                <div style="width:84%"><img style="width:100%" src="../assets/main5.jpg" alt="" ></div>
          </div>

          <!-- <div style="width:100%;position: absolute;bottom:4vh"></div> -->
          <div @mouseleave="mouseLeaveHandler" @mouseenter="mouseEnterHandler" class="main_bottom_button" @click="todata">
            <span v-if="istextShow">数据中心</span> 
            <img src="../assets/arrow-circle-right.svg" style="height:2.5vh;width:2.5vh;position: absolute;right:8px" alt="">
            </div>
        </div>
        <div class="dbitem">
          <div class="dbitems items_active">
            <div class="itemcont_top">
                <img style="height:3vh;width:3vh"src="../assets/tool.svg" alt="SVG图形">
                <span >实用工具</span>
              </div>
              <div class="itemcont_bottom">

                <el-popover placement="right" title="自定义查询条件，快速获取所需数据"  trigger="hover">
                  <div class="popver_continer">
                    
                  </div>
                  <div slot="reference">
                    <span class="spanitem">自定义查询</span><br>
                  </div>
                </el-popover>
                <el-popover placement="right" title="直观的图表展示变化趋势和空间分布"  trigger="hover">
                  <div class="popver_continer">
                   
                  </div>
                  <div slot="reference">
                    <span class="spanitem">可视化图表</span><br>
                  </div>
                </el-popover>
                <el-popover placement="right" title="一键生成定制化的分析报告，便于企业决策。"  trigger="hover">
                  <div class="popver_continer">
                    
                  </div>
                  <div slot="reference">
                    <span class="spanitem">报告生成</span><br>
                  </div>
                </el-popover>


                
              </div>
          </div>
          <div class="dbitems items_active">
            <div class="itemcont_top">
                <img style="height:3vh;width:3vh"src="../assets/gov.svg" alt="SVG图形">
                <span>政策支持</span>
              </div>
              <div class="itemcont_bottom">

                <el-popover placement="right" title="数据库正在逐步细化到县级层面" width="350" trigger="hover">
                  <div class="popver_continer">
                    
                  </div>
                  <div slot="reference">
                    <span class="spanitem">县级数据细化</span><br>
                  </div>
                </el-popover>

                <el-popover placement="right" title="将建立动态的排放因子数据库" width="350" trigger="hover">
                  <div class="popver_continer">
                    
                  </div>
                  <div slot="reference">
                    <span class="spanitem">排放因子库 </span><br>
                  </div>
                </el-popover>

                <el-popover placement="right" title="将提供区域适宜的减排技术建议" width="350" trigger="hover">
                  <div class="popver_continer">
                    
                  </div>
                  <div slot="reference">
                    <span class="spanitem">减排技术推荐</span><br>
                  </div>
                </el-popover>

                
              </div>
          </div>
        </div>
      </div>
    </div>
    
    
  </div>
</template>

<script>
import * as echarts from 'echarts'
import chinadata from '@/assets/china.json'
export default {
  name: 'HelloWorld',
  data(){
    return{
        istextShow:false,
        allprovincesData:[],
        timerlock:false,
        loading:true,
        myChart:null,
        option:null,
        timer:null,
        playtime:0,
        texts:[{title:'为政府部门提供决策依据',
        data:'政府部门可以利用数据库提供的详尽数据和分析结果，制定更加科学合理的农业减排策，实现农业低碳发展。',
        src:require('../assets/banner_01.png')},
        {title:'为科研单位提供技术和数据支撑',data:'科研机构可以借助数据库中的丰富数据，开展农业领域减排固碳研究，研发农业减排固碳新技术，探索农业绿色低碳发展的新路径。',src:require('../assets/banner_02.png')},
        {title:'为农业企业低碳发展提供技术服务',data:'农业企业可以通过数据库了解自身产品的碳足迹，优化生产流程，提供低碳农产品综合解决方案，提升低碳农产品的品牌价值。',src:require('../assets/banner_03.png')},
        {title:'公众教育',data:'数据库还可以作为公众了解农业领域应对气候变化的窗口，增强社会对农业生产系统温室气体排放的认知，提升公众对农业绿色低碳发展的关注和支持。',src:require('../assets/banner_04.png')}
        ]
    }
  },
  mounted(){
    
  },
  methods:{
    mouseLeaveHandler(){
      
      this.istextShow=false
    },
    mouseEnterHandler(){
      setTimeout(() => {
        this.istextShow=true
      }, 300);
    },
    todata(){
      this.$router.push('/index')
    }
  }
}
</script>


<style>
.indexcontiner{
  height: 100%;
  width: 100%; 
  background-color: #f0f0f4;
  overflow-y: auto !important;
}
.el-carousel__container{
    
} 
.car_continer{
  position: relative;
  height:65vh;
  width:100%;
  
}
.updata{
    margin-left: 60px;
    margin-top: 10px;
    display: flex;
    height: 30px;
    width: 90%;
    background-color: #1d466b;
     border-radius: 15px;
     border: black 2px solid;
     justify-content: center;
     align-items: center;

}
.updata div{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}
.indexmain{
    display: flex;
   margin-top: 20px;
   width: 100%;
   justify-content: center;
   align-items: center;
}

.el-carousel{
  width: 100%;
  height: 65vh;
  
}
.el-carousel__container{
  height: 65vh !important;
}
.dbchar{
  padding-top: 50px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 65vh;
  
}
.dbcontiner{
  margin-top: 40px;
  display: flex;
  flex: 1;
  width: 90%;
  justify-content: space-evenly
}
.dbitem{
  width: 30%;
  height: 100%;
}
.dbmain{
  overflow: hidden;
  width: 30%;
  height: 90%;
  background-color: #fff;
  border-radius: 20px;
  position: relative;
  /* padding: 15px; */
 box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.5); /* 主阴影 */
    transform: rotateY(10deg);
  transition: all 0.3s ease;
}
.dbitems{
  width: 100%;
  height: 40%;
  margin-bottom: 10%;
  background-color: #fff;
  border-radius: 20px;
  position: relative;
  /* padding: 15px; */
  box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.5); /* 主阴影 */
    transform: rotateY(10deg); /* 绕Y轴旋转10度 */
  transition: all 0.3s ease;
}
/* .items_active:hover {
  transform: scale(1.1); 
  box-shadow: 8px 8px 12px 0px rgba(0, 0, 0, 0.5); 

} */


.itemcont_top{
  position: absolute;
  left: 15px;
  top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.itemcont_top span{
  /* letter-spacing: 0.1em; */
  font-weight: 700;
  margin-left:10px;
  font-size: 3vh;
}
.itemcont_bottom{
  position: absolute;
  left: 15px;
  bottom: 15px;
  display: flex;
  flex: 1;
  flex-direction: column;
}
.itemcont_bottom span{
  font-size: 2.4vh;
  line-height: 1.5;
  letter-spacing: 0.1em;
  color: #737b89;
  text-align: start;
  cursor: pointer;
}
.itemcont_bottom span:hover{
  color: #1d466b;
  font-weight: 600;
}
.spanitem::before {
    content: "• ";
    color: #1d466b;
    font-size: 2.6vh; 
}
.itemcont_main_bottom{
  width:100%;
  /* margin-left: 15px; */
  position: absolute;
  /* left: 15px; */
  padding-left: 8%;
  top: 10vh;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.itemcont_main_bottom span{
  font-size: 2.4vh;
  line-height: 1.5;
  letter-spacing: 0.1em;
  color: #737b89;
  text-align: start !important;
  cursor: pointer;
}
.itemcont_main_bottom span:hover{
  color: #1d466b;
  font-weight: 600;
}
.main_bottom_button{
  position: absolute;
  padding: 8px;
  width: 2.5vh;
  height: 2.5vh;
  right: 1.5vh;
  bottom: 1.5vh;
  background-color:  #1d466b ;
  border-radius: 2vh;
  color: #fff;
  font-weight: 700;
  font-size: 2vh;
  display: flex;

  align-items: center;
  cursor: pointer;
  transition: width 0.3s ease 0s, height 0.3s ease 0s;
}

.main_bottom_button:hover{
   
    width: 11vh;
    height: 2.5vh; 
}

.carousel_text{
  position: absolute;
  width:100%;
  z-index:10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  background: linear-gradient(180deg, rgba(29,70,107, 1), rgba(29,70,107, 0) 10%);
   
    
}
.car_title{
  font-size: 6vh;
  color: #fff;
  font-weight: 700;
}
.car_data{
  width: 80%;
  margin-top: 80px;
  font-size: 4vh;
  color: #cff1ea;
  font-weight: 700;
}
.popver_continer{
  width: 35vh;
  
}
.popver_continer img{
  width: 100%;
  
}
.indexcontiner.el-popover{
  border-radius: 8px !important;
  width: 35vh !important;
}
.el-popover__title{
  font-size: 2vh;
}
</style>